/**
 * Shared failure message for the "open the storefront as an admin" flow.
 *
 * The API names the cause on this path — a rejected service credential, or the storefront service
 * refusing the sign-in — and that detail is the difference between an admin who can act on it and
 * one who files a ticket, so it is passed through whenever it is present.
 *
 * The API's exception middleware serializes ActionResponse with default options rather than the
 * camelCase pipeline, so the error body arrives PascalCase. Both spellings are read: the fallback
 * costs nothing and outlives whichever way that middleware settles.
 */
export const SESSION_ERROR = 'Could not start a storefront session.';

export const sessionErrorFrom = (error: unknown): string => {
    const data = (error as { data?: { Message?: string; message?: string } } | undefined)?.data;
    return data?.Message || data?.message || SESSION_ERROR;
};
